export default __webpack_public_path__ + "static/media/Gum 3.5c74762a.png";